
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { day: 'Mon', score: 720, steps: 7500, sleep: 7.2 },
  { day: 'Tue', score: 740, steps: 8200, sleep: 8.1 },
  { day: 'Wed', score: 735, steps: 6800, sleep: 7.5 },
  { day: 'Thu', score: 755, steps: 9100, sleep: 8.3 },
  { day: 'Fri', score: 742, steps: 8247, sleep: 7.9 },
  { day: 'Sat', score: 760, steps: 10200, sleep: 8.5 },
  { day: 'Sun', score: 745, steps: 7800, sleep: 8.0 }
];

export const ActivityChart = () => {
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
          <XAxis 
            dataKey="day" 
            axisLine={false}
            tickLine={false}
            className="text-xs"
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            className="text-xs"
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Line 
            type="monotone" 
            dataKey="score" 
            stroke="hsl(162, 68%, 33%)" 
            strokeWidth={3}
            dot={{ fill: 'hsl(162, 68%, 33%)', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, fill: 'hsl(162, 68%, 33%)' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
